<template>
  <div class="w-full h-full flex items-center justify-center">
    <div class="flex flex-col my-8 justify-around">
      <h1>
        Please enter your email address
      </h1>
      <div class="mt-4">
        <TextInput ref="email" placeholder="E-Mail Address"></TextInput>
      </div>
      <div class="w-1/2 mx-auto mt-4">
        <JButton @click="login" label="Login" :isWhite="false"></JButton>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import TextInput from '@/components/TextInput'
import JButton from '@/components/JButton'
export default {
  name: 'EmailSignIn',
  components: { TextInput, JButton },
  methods: {
    async login () {
      const email = this.$refs.email.getValue()
      const user = await firebase.auth().signInWithEmailLink(email, window.location.href)
    }
  }
}
</script>
